
/* injects from baggage-loader */

'use strict';

import _ from 'lodash';

import { intro_bg1 } from '_images/intro/intro-bg-1.png';


export default class LoginController {
    constructor($rootScope, $log, $state, $timeout, Session, Dialog) {
        'ngInject';
        this.$log = $log;
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.Session = Session;
        this.Dialog = Dialog;
        this.intro_bg1 = intro_bg1;
        this.$timeout = $timeout;
        this.passPage = false;

        this.state = {
            step: 1
        }
    }

    $onInit(){
        let data = this.Session.get();
        
        if (!_.isEmpty(data)){
            this.$state.go("main");
        }
    }

    toggleCredits(bol){
        this.credits = bol;
    }

    showIntro() {
        let $ctrl = this;
        this.state.step = 2;
        this.$timeout(()=> $ctrl.passPage = true,3000)
    }

    redirectToStages(){
        this.Session.create();
        this.$state.go("page-two");
    }
}


// WEBPACK FOOTER //
// ./src/app/pages/login/login.controller.js